/* global tabs */

import {MDCTabBar} from '@material/tabs';
import {MDCToolbar} from '@material/toolbar';
import scrollToElement from 'scroll-to-element';

const toolbar = MDCToolbar.attachTo(document.querySelector('.mdc-toolbar'));
toolbar.fixedAdjustElement = document.querySelector('.mdc-toolbar-fixed-adjust');

for (let key in tabs) {
    const tabBar = new MDCTabBar(document.querySelector(`.${tabs[key]}-tab-bar`));
    tabBar.listen('MDCTabBar:change', ({detail: {activeTabIndex}, target: {id}}) => {
        const panels = document.querySelector(`.${id}-panels`);
        const activePanel = panels.querySelector('.panel.active');

        if (activePanel) {
            activePanel.classList.remove('active');
        }

        const newActivePanel = panels.querySelector(`.panel:nth-child(${activeTabIndex + 1})`);

        if (newActivePanel) {
            newActivePanel.classList.add('active');
        }
    });
    tabBar.preventDefaultOnClick = true;
}

Array.from(document.querySelectorAll('a')).filter(element =>
    element.hasAttribute('scroll-to')
).forEach(element => {
    element.addEventListener('click', (event) => {
        event.preventDefault();

        scrollToElement(element.getAttribute('scroll-to'), {
            ease: 'in-out-expo',
            duration: 500
        });
    });
});



// WEBPACK FOOTER //
// ./themes/default/source/js/_application.js